import { all } from 'redux-saga/effects';
import { featuresSagas } from 'features';

export function* rootSaga() {
  yield all(featuresSagas());
}
